module.exports = __webpack_public_path__ + "img/gratification-upload.8d960221.svg";